/**
 * Утилиты для выбора локализованного значения из данных БД.
 *
 * В БД некоторые поля хранятся как объект `{ ru, ky, en }` (например,
 * `event.name`, `event.description`). Этот хелпер выбирает нужный
 * язык с fallback-ами и защищает от `null/undefined`.
 *
 * Использовать вместо `i18n.language === 'ky' ? x.ky : x.ru`.
 */

export type LocalizedText =
  | string
  | { ru?: string; ky?: string; kg?: string; en?: string }
  | null
  | undefined;

/**
 * Возвращает строку на нужном языке. Порядок fallback:
 * requested → ru → en → ky/kg → пустая строка.
 * Поддерживает legacy-ключ `kg` (использовался раньше вместо `ky`).
 */
export function getLocalized(text: LocalizedText, lang: string): string {
  if (!text) return '';
  if (typeof text === 'string') return text;
  if (typeof text !== 'object') return String(text);

  // Нормализуем язык: 'ky-KG' → 'ky'
  const normLang = lang.split('-')[0].toLowerCase();

  // Сначала запрошенный язык (учитывая legacy 'kg')
  if (normLang === 'ky') {
    if (text.ky) return text.ky;
    if (text.kg) return text.kg;
  } else if (normLang === 'ru' && text.ru) {
    return text.ru;
  } else if (normLang === 'en' && text.en) {
    return text.en;
  }

  // Fallback-цепочка
  return text.ru || text.en || text.ky || text.kg || '';
}
